/**
 * 首击立即执行，随后 waitMs 内忽略重复触发（发送/停止防连点；非 lodash 的 trailing debounce）
 * @param {Function} fn
 * @param {number} [waitMs=350]
 * @returns {Function & { cancel: () => void }}
 */
export function debounceLead (fn, waitMs = 350) {
  let lockedUntil = 0
  function wrapped (...args) {
    const now = Date.now()
    if (now < lockedUntil) return
    lockedUntil = now + waitMs
    return fn.apply(this, args)
  }
  wrapped.cancel = () => {
    lockedUntil = 0
  }
  return wrapped
}



// WEBPACK FOOTER //
// ./src/utils/debounceLead.js